import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LANGUAGE } from 'constants/common';
import UK from './locales/UK.json';
import EN from './locales/EN.json';

const resources = {
  uk: UK,
  en: EN,
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: ENVIRONMENT_VARIABLES?.language || DEFAULT_LANGUAGE,
    defaultNS: 'pages',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
    fallbackNS: 'form',
  });

export default i18n;

document.documentElement.setAttribute('lang', i18n.language);
